'use strict';

module.exports = function (row, event) {

  var data;
  var id = this.opts.uniqueKey;

  if (this.source == 'client' && typeof row[id] !== 'undefined') {
    data = this.tableData.filter(function (r) {
      return row[id] === r[id];
    })[0];
  } else {
    data = row;
  }

  this.dispatch('row-click', { row: data, event: event });
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/row-was-clicked.js
// module id = 1060
// module chunks = 0